export default __webpack_public_path__ + "static/media/cycloneofsteel8.f6f87927.png";